<div class="spinner-wrapper">
  <div class="spinner-wrapper__title" *ngIf="showTitle">
    <h1>{{ title }}</h1>
    <h3>{{ subTitle }}</h3>
  </div>
  <mat-spinner class="spinner"></mat-spinner>
</div>
